import { useEffect, useState } from "react"

export function useViewerStore(viewer, storeName) {
  const [state, setState] = useState(null)

  useEffect(() => {
    if (!viewer || viewer.isDisposed) {
      setState(null)
      return
    }

    const getter = storeGetters[storeName]
    if (getter) {
      setState(getter(viewer))
    }

    const unsub = viewer.subscribe(storeName, (next) => {
      setState(next)
    })

    return unsub
  }, [viewer, storeName])

  return state
}

const storeGetters = {
  stats: (v) => v.getStats(),
  camera: (v) => v.getCameraSettings(),
  grid: (v) => v.getGridSettings(),
  wireframe: (v) => v.getWireframeSettings(),
  scene: (v) => v.getSceneSettings(),
  environment: (v) => v.getEnvironmentSettings(),
  renderMode: (v) => v.getRenderModeSettings(),
  models: (v) => ({
    loadedModels: v.getLoadedModels(),
    isLoading: v.isLoading(),
  }),
  meshList: (v) => ({ meshes: v.getMeshList() }),
  explodedView: (v) => v.getExplodedViewSettings(),
  selection: (v) => v.getSelectionSettings(),
}

